export default {
  setUserFiles(state, payload) {
    state.files = payload;
  },
};